import { expandGitRenameNumstatPath } from '../parse/expand-git-rename-numstat-path.js';
import { isBinaryNumstatLine } from '../numstat/is-binary-numstat-line.js';

export function collectBinaryPathsFromNumstat(numstatRaw: string): Set<string> {
  const binaryByPath = new Set<string>();
  for (const line of numstatRaw.split('\n')) {
    if (!line.trim()) continue;
    const parts = line.split('\t');
    if (parts.length < 3) continue;
    const rawPath = parts[parts.length - 1]!;
    const expanded = expandGitRenameNumstatPath(rawPath);
    if (isBinaryNumstatLine(line)) binaryByPath.add(expanded?.newPath ?? rawPath);
  }
  return binaryByPath;
}
